<template>
<modal name="tryt-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeTrytDialog"
      icon="el-icon-circle-close-outline"
      style="font-size: 2rem;"
      type="text"></el-button>
  </div>
  <div class="setting" v-if="permissionType == 2">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 150%;">もうすぐで完了するよ！</p>
      <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/tryt_yagish_logo.png" style="width:100%" >
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
        <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
      </div>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link><br/>
        (株)トライトキャリアの<a href="https://tryt-career.co.jp/sitepolicy/" target="_blank">利用規約</a>、<a href="https://tryt-career.co.jp/handling/" target="_blank">個人情報の取扱い</a><br/>
         ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a><br/>
        アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >上記規約に同意して、会員登録を希望する
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
      <p style="font-size: 140%;"> 
        <el-checkbox v-model="isAgree" style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談や<br>求人受取、会員登録を希望する</el-checkbox>
      </p>
      <br/>
    </div>
    <div class="text-center" style="padding:10px">
      <el-button id="send-adtop-pdf" type="success" v-if="isTrytSended == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-tryt-consult');">看護師を希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isTrytSended == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeTrytDialog();">送信しました</el-button>
      <br/>
    </div>
    <div class="text-center" style="padding:10px" v-if="false">
      <el-button id="send-adtop-pdf" type="success" v-if="isMedlySended == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-medley-consult-tryt');">その他の師業を希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isMedlySended == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeTrytDialog();">送信しました</el-button>
      <br/>
    </div>
    <div class="text-center" style="padding:10px">
      <el-button id="send-adtop-pdf" type="success" v-if="isAdtopSended == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-adtop-consult-tryt');">その他の正社員を希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isAdtopSended == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeTrytDialog();">送信しました</el-button>
      <br/>
    </div>
    <div class="text-center" style="padding:10px">
      <el-button id="send-adtop-pdf" type="success" v-if="isJigenSended == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-jigen-consult-tryt');">アルバイトを希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isJigenSended == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeTrytDialog();">送信しました</el-button>
      <br/>
    </div>
  </div>
  <div class="setting" v-else-if="permissionType == 1">
        <div style="text-align: center;">
        <p style="font-size: 120%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 90%; padding-bottom: 5px;">作成した履歴書からおすすめの求人をご紹介！</p>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
            <p style="font-size: 150%; font-weight: bold;">看護師<span style="font-size: 80%;">の</span>求人<span style="font-size: 80%;">を</span>探したい方<span style="color:rgb(246, 11, 38)">必見！</span></p>  
            <p style="font-size: 140%;">
                <img src="/static/renew_img/tryt_yagish_logo.png" style="width:90%" >
            </p>
        </div> 
        <div style="display: inline-block; min-width: 100%; text-align: center;">
            <p style="font-size: 110%; padding-bottom: 30px;"><span style="background: linear-gradient(transparent 60%, #FFCCCC 50%);">看護師の人材紹介サービス</span>に特化した、
                <br><span style="font-weight: bold; font-size: 130%;">「トライトキャリア」</span>が親身な応援、誠実で的確な
                <br>コンサルティングであなたのキャリアをサポートします！</p>
        </div>
        <div>
            <div style="margin-bottom: 40px;"><!--規約等とボタンのセット-->
                <!--ここにチェックボックス入れる-->
                <p style="padding-bottom: 5px;font-size: 60%;">
                        <el-checkbox v-model="isAgree" style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
                        </el-checkbox>
                        (株)トライトキャリアの
                        <a href="https://tryt-career.co.jp/sitepolicy/" class="" id="footer-link-terms" target="_blank">利用規約</a>・
                        <a href="https://tryt-career.co.jp/handling/" class="" id="footer-link-policy" target="_blank">個人情報の取扱い</a>
                        に同意する
                </p>
                <div style="width: 90%; margin: 0 auto;">
                    <!--<p style="font-size: 120%; font-weight: bold; padding-right: 15px;">看護師を希望</p>-->
                    
                    <el-button id="send-adtop-pdf" type="success" v-if="isTrytSended == false && isAgree == false"
                    style="background-color: rgb(255, 255, 255); border-color: rgb(246, 11, 38); font-size: 120%;color:rgb(0, 0, 0)"
                      @click="$eventHub.$emit('send-tryt-consult');"><span style="font-size: 80%; line-height: 1rem;">上記の規約に同意して<br>会員登録を希望する</span></el-button>
                    <el-button id="send-adtop-pdf" type="success" v-else-if="isTrytSended == false && isAgree == true"
                    style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%;"
                      @click="$eventHub.$emit('send-tryt-consult');"><span style="font-size: 80%; line-height: 1rem;">上記の規約に同意して<br>会員登録を希望する</span></el-button>
                    <el-button id="send-adtop-pdf" type="success" v-else-if="isTrytSended == true"
                    style="background-color:#0F9934;border-color:#0F9934;"
                      @click="closeTrytDialog();"><span style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>
                      
                    <p style="font-size: 80%;">※(株)トライトキャリアへの登録</p>
                </div>  
            </div>
            <div style="display: inline-block; min-width: 100%; text-align: center;">
                <p style="font-size: 120%;">ご同意いただいた方には、
                    <br><span style="font-weight: bold;">電話もしくはメール</span>にてご連絡いたします。
                </p>
                <p style="font-size: 80%;">※会員登録へのボタンを押した場合、
                    <br>規約に同意したとみなします。
                </p>
                <p style="margin: 20px 40px;">（yagishの
                    <a href="/terms" class="" id="footer-link-terms" target="_blank">利用規約</a>・
                    <a href="/privacy" class="" id="footer-link-policy" target="_blank">個人情報保護方針</a>）
                    <br>※会員登録へのボタンを押した場合、規約に同意したとみなします。
                    <br>※yagishの採用への応募ではありません。
                </p>
            </div>

        </div>

    </div>    
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isTrytSended:false,
      isMedlySended:false,
      isAdtopSended:false,
      isJigenSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:false,
      medleyID:7,
      medleyPCLnks: {
        1:'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2:'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3:'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5:'https://job-medley.com/lp/dh/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6:'https://job-medley.com/lp/da/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7:'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      },
      medleySPLnks: {
        1:'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2:'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3:'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5:'https://job-medley.com/lp/dh/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6:'https://job-medley.com/lp/da/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7:'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      }
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openTrytDialog: function (id, html) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('tryt-dialog')
      this.clearLocalStorageConfirmVisible = false

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'tryt_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'd')
      formData.append('app_flag', '')
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeTrytDialog: function () {
      this.$modal.hide('tryt-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendTrytConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'tryt_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '5')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendTryt, formData, {timeout: 60000})
        .then(function (response) {
          app.isTrytSended = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendAdtopConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'tryt_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isAdtopSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたに電話・メールでご連絡することがあります！`,
            type: 'error'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendMedleyConsult: async function () {
      console.error('sendMedleyConsult')
      if (!this.isAgree) {
      console.error('チェックしてから同意ボタンを押してください。')
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (this.$deviceLib.isMobileDevice == 'SP') {
        window.open(this.medleySPLnks[this.medleyID], '_blank')
      } else {
        window.open(this.medleyPCLnks[this.medleyID], '_blank')
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'tryt_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendLinkMedley, formData, {timeout: 60000})
        .then(function (response) {
          app.isMedleySended = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendJigenConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const jigen_url = 'https://arubaito-ex.jp/search?kw=&form_type=header_search&ref_code=oem_register_yagish_link&utm_source=register_yagish_link&utm_medium=oem'
      window.open(jigen_url, '_blank')
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'tryt_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendJigen, formData, {timeout: 60000})
        .then(function (response) {
          app.isJigenSended = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-adtop-consult-tryt', this.sendAdtopConsult)
    this.$eventHub.$on('send-medley-consult-tryt', this.sendMedleyConsult)
    this.$eventHub.$on('send-jigen-consult-tryt', this.sendJigenConsult)
    this.$eventHub.$on('send-tryt-consult', this.sendTrytConsult)
    this.$eventHub.$on('open-tryt-dialog', this.openTrytDialog)
    this.$eventHub.$on('popstate', this.closeTrytDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-adtop-consult-tryt', this.sendAdtopConsult)
    this.$eventHub.$off('send-medley-consult-tryt', this.sendMedleyConsult)
    this.$eventHub.$off('send-jigen-consult-tryt', this.sendJigenConsult)
    this.$eventHub.$off('send-tryt-consult', this.sendTrytConsult)
    this.$eventHub.$off('open-tryt-dialog', this.openTrytDialog)
    this.$eventHub.$off('popstate', this.closeTrytDialog)
  }
}
</script>
